import { createFileRoute } from "@tanstack/react-router";
import { TasterList } from "@/features/food-sensory/tasters/taster-list";

export const Route = createFileRoute("/food-app/tasters/")({
  component: TastersPage,
});

function TastersPage() {
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <h1 className="text-base font-semibold">Tasters</h1>
        <p className="text-sm text-muted-foreground">
          Everyone who has joined a tasting, and how much Farmless ingredient each has been served over all of them.
        </p>
      </div>
      <TasterList />
    </div>
  );
}
